var ejs = require("ejs");

var $stepSelector = $("#step-selector"),
  $stepContainer = $("#step-container"),
  $capHeader = $("#cap-header"),
  $capWrap = $("#create"),
  $toggleExpandedOpts = $(".cap-show-expanded-options"),
  $preview = $("#connector-preview"),
  $previewImages = $("#connector-preview__images"),
  $previewBackground = $("#connector-preview__background"),
  $previewWidthWrap = $("#connector-preview__width-wrap"),
  $previewWidth = $("#connector-preview__width"),
  $previewMeta = $("#connector-preview__meta"),
  $previewGenderNotice = $previewMeta.find(".view-gender"),
  $previewDownloadForm = $previewMeta.find("form"),
  optionTemplateJs = require("./templates/option.ejs.txt"),
  categoryTemplateJs = require("./templates/category.ejs.txt"),
  stepTemplateJs = require("./templates/step.ejs.txt"),
  optionTemplate = ejs.compile(optionTemplateJs),
  categoryTemplate = ejs.compile(categoryTemplateJs),
  stepTemplate = ejs.compile(stepTemplateJs),
  offFoot,
  offCap,
  hCap,
  hWin,
  hFoot;

function setBaseVals() {
  hCap = $capHeader.outerHeight();
  offCap = $capHeader.offset().top;
  hWin = $(window).height();
  hFoot =
    $(".layout-footer").outerHeight() + $(".footer-copyright").outerHeight();
  offFoot = $(".layout-footer").offset().top;

  $capWrap.css("padding-top", hCap);

  // console.log('hCap: ', hCap);
  // console.log('offCap: ', offCap);
  // console.log('hWin: ', hWin);
  // console.log('hFoot: ', hFoot);
  // console.log('offFoot: ', offFoot);
}
$(window).resize(setBaseVals);

function loadOption(optionData) {
  var defaults = {
    id: "",
    name: "",
    code: "",
    image: "",
    type: "",
    width: false,
    display_name: "",
    description: "",
    options: [],
    optionsHTML: "",
  };

  // apply defaults
  optionData = $.extend(true, {}, defaults, optionData);

  // render and return
  return optionTemplate(optionData);
}

function loadStepCategory(categoryData) {
  var defaults = {
    id: "",
    name: "",
    options: [],
    optionsHTML: "",
  };

  // apply defaults
  categoryData = $.extend(true, {}, defaults, categoryData);

  // sort options
  if (categoryData.options_order)
    categoryData.options.sort(function (a, b) {
      return (
        categoryData.options_order.indexOf(a.id) -
        categoryData.options_order.indexOf(b.id)
      );
    });

  // determine if all category options are expanded opts
  categoryData.isExpanded = categoryData.options.every(function (opt) {
    return opt.type == 2;
  });

  // render options
  $.each(categoryData.options, function (i, option) {
    categoryData.optionsHTML += loadOption(option);
  });

  // render and return
  return categoryTemplate(categoryData);
}

function scrollToCapTop() {
  if ($("body").scrollTop() < offCap) return;

  $("html, body").animate(
    {
      scrollTop: offCap,
    },
    250
  );
}

function setupScrollingListeners() {
  var $body = $("body"),
    isStuck = false;

  $capHeader.addClass("ready");
  setBaseVals();

  if ($(window).width() < 736) return;

  $(window).scroll(function () {
    // console.log($body.scrollTop());

    if (hWin < hCap * 2)
      return $capHeader.removeClass("is-sticky").removeClass("is-bottomed");

    if ($body.scrollTop() < offCap) {
      if (isStuck) isStuck = false;

      $capHeader.removeClass("is-sticky").removeClass("is-bottomed");
    } else if (
      $body.scrollTop() > offCap &&
      $body.scrollTop() < offFoot - hCap
    ) {
      if (!isStuck) isStuck = true;

      $capHeader.addClass("is-sticky").removeClass("is-bottomed");
    } else {
      if (!isStuck) isStuck = true;

      $capHeader.addClass("is-bottomed");
    }
  });
}

function loadStep(stepData) {
  var stepHTML,
    $step,
    defaults = {
      id: "",
      name: "",
      order: 0,
      categories_order: false,
      description: "",
      leading_character: false,
      categories: [],
      categoriesHTML: "",
    };

  // apply defaults
  stepData = $.extend(true, {}, defaults, stepData);

  // sort categories
  if (stepData.categories_order)
    stepData.categories.sort(function (a, b) {
      return (
        stepData.categories_order.indexOf(a.id) -
        stepData.categories_order.indexOf(b.id)
      );
    });

  // render categories
  $.each(stepData.categories, function (i, categoryData) {
    stepData.categoriesHTML += loadStepCategory(categoryData);
  });

  // render template
  stepHTML = stepTemplate(stepData);
  $step = $(stepHTML);

  // append new els

  // has leading character?
  if (stepData.leading_character && 0)
    $stepSelector.append("<span>" + stepData.leading_character + "</span>");

  // regular selector button
  $stepSelector.append(
    '<button type="button" data-step-id="' + stepData.id + '"></button>'
  );

  // give all options in this step the same name
  $step.find("input").attr("name", "step-choice-" + stepData.id);

  // if no expanded options on this step, hide toggle
  if ($step.find(".option-type-2").length == 0)
    $step.find(".cap-options").hide();

  $stepContainer.append($step[0]);
}

function disableImagePreview() {
  $previewImages.hide();
  $previewGenderNotice.hide();
  $previewDownloadForm.hide();
}

function enableImagePreview() {
  $previewImages.show();
  $previewGenderNotice.show();
  $previewDownloadForm.show();
}

module.exports = {
  renderSeries: function (stepsData) {
    // make sure expanded options are unchecked on load
    $toggleExpandedOpts.prop("checked", false);

    // add class for progress button sizing
    $stepSelector.addClass("step-count-" + (stepsData.length + 1));

    // load em all!
    stepsData.forEach(function (step) {
      loadStep(step);
    });

    $capWrap.css("height", "auto");
    $capWrap.find(".loading-absolute").hide();
    $capWrap.find(".cap-show-expanded-wrap").show();

    setTimeout(setupScrollingListeners, 250);
  },

  scrollToCapTop: scrollToCapTop,

  // for Scorpion-style preview
  drawPreviewModular: function (opts) {
    /*
		opts: {
			images: [
				{
					src: 'img.png',
					flip: true
				}
			],
			width: 50,
			max_width: 100,
		}
		 */

    var newContent = "",
      mirroredImages = [],
      defaults = {
        images: [],
        width: 0,
        maxWidth: 0,
      };

    // apply defaults
    opts = $.extend(true, {}, defaults, opts);

    if (opts.images.length == 0 || opts.images === false) disableImagePreview();
    else enableImagePreview();

    // build html
    $.each(opts.images, function (order, image) {
      newContent +=
        '<img src="' +
        window.CAP_IMG_DIR +
        "/" +
        image.src +
        '" alt="" class="component" />';

      if (image.flip) mirroredImages.unshift(image);
    });

    // ...and add the mirrored version if we have any
    $.each(mirroredImages, function (order, image) {
      newContent +=
        '<img src="' +
        window.CAP_IMG_DIR +
        "/" +
        image.src +
        '" alt="" class="component reversed" />';
    });

    $preview.show();
    $previewImages.html(newContent);

    var widthDisplay =
      typeof opts.width === "string" ? opts.width : opts.width.toFixed(2);
    $previewWidth.text(widthDisplay);

    setBaseVals();
  },

  // for GG-style preview
  drawPreviewFixed: function (opts) {
    /*
		opts: {
			images: ['img.png'],
			placeholder: 'img.png',
			num_modules: 4,
			template: 'img.png'
		}
		 */

    var newContent = "",
      defaults = {
        images: [],
        placeholder: false,
        num_modules: 1,
        template: "",
      };

    // apply defaults
    opts = $.extend(true, {}, defaults, opts);

    if (opts.images.length == 0 || opts.images === false) disableImagePreview();
    else enableImagePreview();

    // require placeholder
    if (!opts.placeholder || !opts.placeholder.length) return $preview.hide();

    // build html
    var imageCount = 0;
    $.each(opts.images, function (order, image) {
      newContent +=
        '<img src="' +
        window.CAP_IMG_DIR +
        "/" +
        image +
        '" alt="" class="component fixed" />';

      imageCount++;
    });

    // add placeholders to remaining slots
    for (var i = imageCount; i < opts.num_modules; i++)
      newContent +=
        '<img src="' +
        window.CAP_IMG_DIR +
        "/" +
        opts.placeholder +
        '" alt="" class="component fixed" />';

    $previewImages.html(newContent);
    $previewBackground
      .attr("src", window.CAP_IMG_DIR + "/" + opts.template)
      .show();

    $preview.show();
    $previewWidthWrap.hide();
    setBaseVals();
  },
};
